import axios from "axios";
import { logError } from "../services";

interface RecommendationPayload {
  query: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  fsa?: string;
}

interface RefinedRecommendationsPayload {
  answers: Array<string>;
  questions: Array<string>;
  query: object;
  recommendation: string;
}

const getApiBaseUrl = () => {
  if (!window.config?.reco_engine_api_proxy) {
    throw new Error("Reco engine API proxy not configured");
  }
  return window.config.reco_engine_api_proxy;
};

export const postRecommendations = async (payload: RecommendationPayload) => {
  try {
    const API_BASE_URL = getApiBaseUrl();
    const response = await axios.post(
      `${API_BASE_URL}/recommend`,
      payload 
    );
    return response.data;
  } catch (error) {
    logError("Failed to get recommendations", error);
    throw new Error("Failed to fetch recommendations", error);
  }
};

export const getQuestions = async (message: string, query: string) => {
  const params = new URLSearchParams({
    query: query,
    recommendation: message?.replace(/\s+/g, " ").slice(0, 100),
  });

  try {
    const API_BASE_URL = getApiBaseUrl();
    const response = await axios.get(`${API_BASE_URL}/questions?${params.toString()}`);
    return response.data;
  } catch (error) {
    logError("Failed to get questions", error);
    throw new Error("Failed to fetch questions", error);
  }
};

export const getRefinedRecommendations = async (payload: RefinedRecommendationsPayload) => {
  try {
    const API_BASE_URL = getApiBaseUrl();
    const response = await axios.post(
      `${API_BASE_URL}/refine_recommendations`,
      payload
    );
    return response.data;
  } catch (error) {
    logError("Failed to get refined recommendations", error);
    throw new Error("Failed to fetch refined recommendations", error);
  }
};